import { EntityEdge, moveToFulfilled, moveToPending, moveToRejected, update } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { FollowTopicFulfilledAction, UnfollowTopicFulfilledAction } from '../../domains/topicFollow/actions.types';
import {
  TopicFollowersLoadFulfilledAction,
  TopicFollowersLoadPendingAction,
  TopicFollowersLoadRejectedAction,
} from '../../domains/topicFollowers/loadActions.types';
import { TopicFollowersLoadMoreFulfilledAction } from '../../domains/topicFollowers/paginateActions.types';
import { User } from '../users/types';

import { TopicFollowers } from './types';

export type TopicFollowersAction =
  | TopicFollowersLoadFulfilledAction
  | TopicFollowersLoadPendingAction
  | TopicFollowersLoadRejectedAction
  | TopicFollowersLoadMoreFulfilledAction
  | FollowTopicFulfilledAction
  | UnfollowTopicFulfilledAction;

const initialState: TopicFollowers = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const followTopic = (state: TopicFollowers, action: FollowTopicFulfilledAction, userId: User['id']) => {
  const topicId = action.payload.topicId;
  if (!state.fulfilled.byId[topicId]) {
    return state;
  }
  const newFollower: EntityEdge<User> = {
    nodeId: userId,
  };
  const followers = [...state.fulfilled.byId[topicId].followers, newFollower];

  return update(state, topicId, { followers });
};

const unfollowTopic = (state: TopicFollowers, action: UnfollowTopicFulfilledAction) => {
  const topicId = action.payload.topicId;
  if (!state.fulfilled.byId[topicId]) {
    return state;
  }
  const currentFollowers = state.fulfilled.byId[topicId].followers;
  const userId = action.payload.userId;
  const followers = currentFollowers.filter((edge) => edge.nodeId !== userId);

  return update(state, topicId, { followers });
};

const appendMoreFollowers = (state: TopicFollowers, action: TopicFollowersLoadMoreFulfilledAction) => {
  const topicId = action.payload.topicId;
  const topicFollowers = action.payload.entities.topicFollowers[topicId];

  return update(state, topicId, {
    followers: [...state.fulfilled.byId[topicId].followers, ...topicFollowers.followers],
    hasMore: topicFollowers.hasMore,
  });
};

const reducer: Reducer<TopicFollowers, TopicFollowersAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'TOPIC_FOLLOWERS.LOAD_PENDING':
      return moveToPending(state, [action.payload.topicId]);
    case 'TOPIC_FOLLOWERS.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.topicId], action.payload.error);
    case 'TOPIC_FOLLOWERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicFollowers);
    case 'TOPIC_FOLLOWERS.LOAD_MORE_FULFILLED':
      return appendMoreFollowers(state, action);
    case 'TOPIC.FOLLOW_FULFILLED':
      return followTopic(state, action, action.payload.userId);
    case 'TOPIC.UNFOLLOW_FULFILLED':
      return unfollowTopic(state, action);
    default:
      return state;
  }
};
export default reducer;
